export default __webpack_public_path__ + "static/media/accepted.853c8ae4.mp4";